/*props
* src: 图片路径
* handleClick: 处理函数
* */

import React,{Component} from 'react';

export default class AdPosition extends Component{
  render() {
    let styleDiv = {
      width: '100%',
      height: '130px',
      textAligh: 'center',
      cursor: 'pointer'
    };
    let styleImg = {
      width: '100%',
      height: '100%'
    }
    return (
      <div style={styleDiv}>
        <img src={this.props.src} alt="ad" style={styleImg} onClick={this.props.handleClick.bind(this)}/>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Practice/Material/AdPosition.js
 **/